module.exports = __webpack_public_path__ + "static/media/flag-vn.66e76189.png";